import "fullscreen-polyfill";
import { QueryClientProvider } from "@circle-react/providers/QueryClient";
import { ToastProvider } from "@circle-react-uikit/ToastV2";
import { TranscriptsPlayerWrapper } from "@circle-react-uikit/TranscriptsPlayer/TranscriptsPlayerWrapper";
import type { TranscriptsPlayerProps } from "./TranscriptsPlayerComponent";

export const TranscriptsPlayer = (props: TranscriptsPlayerProps) => (
  <QueryClientProvider>
    <ToastProvider>
      <TranscriptsPlayerWrapper {...props} />
    </ToastProvider>
  </QueryClientProvider>
);
